import { render } from "./SocialGitHub.vue?vue&type=template&id=1e6dc010"
import script from "./SocialGitHub.vue?vue&type=script&lang=js"
export * from "./SocialGitHub.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__